
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { HeaderContainer } from '../../styles/Layout.style';
import { 
  LogoContainer, MenuContainer, SignInContainer, MenuItem, MenuItems, MobileMenu, DropdownMenu, DropdownItem, MenuItemArrow,
  LoginStatusBanner, RedLink
} from './Header.style.js';
import Logo from '../../assets/eupha-full-color.png';
import { CiUser,  CiPower } from 'react-icons/ci';
import { IoMenuOutline } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";
import { FaPowerOff } from "react-icons/fa6";
import MenuMobile from '../MenuMobile/MenuMobile.js';

const Header = ({ isLoggedIn, username, onLogout }) => {
  const [linesOpen, setLinesOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <HeaderContainer>
      <LogoContainer>
        <Link to='/'><img src={Logo} alt='Eupha Logo' /></Link>
      </LogoContainer>
      <MenuContainer>
        <MenuItems>
          <MenuItem><RedLink><Link to='/sobre-nosotros'>Familia Eupha</Link></RedLink></MenuItem>
            <MenuItem 
              onMouseEnter={() => setLinesOpen(true)} 
              onMouseLeave={() => setLinesOpen(false)}
            >
              <MenuItemArrow>
              <RedLink><Link to='/lineas'>Líneas</Link></RedLink>
              <IoIosArrowDown />
              </MenuItemArrow>
              
              <DropdownMenu isOpen={linesOpen}>
                <DropdownItem as={Link} to='/lineas/dr-reckeweg/goteros/31'>Dr. Reckeweg</DropdownItem>
                <DropdownItem as={Link} to='/lineas/tegor/depuracion/140'>Tegor</DropdownItem>
                <DropdownItem as={Link} to='/lineas/helixor/helixor-a/266'>Helixor</DropdownItem>
                <DropdownItem as={Link} to='/lineas/symbio-pharm/symbioflor-1/262'>Symbio Pharm</DropdownItem>
                <DropdownItem as={Link} to='/lineas/regenhial/regenhial/269'>Regenhial</DropdownItem>
              </DropdownMenu>
            </MenuItem>
          
          <MenuItem><RedLink><Link to="/eupha-world">Eupha World</Link></RedLink></MenuItem>
          
          <MenuItem 
            onMouseEnter={() => setContactOpen(true)} 
            onMouseLeave={() => setContactOpen(false)}
          >
            <MenuItemArrow>
            <RedLink><Link to='/contacto/contacto'>Contacto</Link></RedLink>
            <IoIosArrowDown />
            </MenuItemArrow>
            <DropdownMenu isOpen={contactOpen}>
              <DropdownItem as={Link} to='/contacto/contacto'>Contáctanos</DropdownItem>
              <DropdownItem as={Link} to='/contacto/unete-al-equipo'>Únete al equipo</DropdownItem>
            </DropdownMenu>
          </MenuItem>
        </MenuItems>
        <MobileMenu>
          <div onClick={() => setIsOpen(!isOpen)}>
            <IoMenuOutline />
          </div>
        </MobileMenu>
        <SignInContainer>
          {isLoggedIn ? (
            <>
              <CiUser />
              <p>Hola, {username}</p>
              <LoginStatusBanner>
              <FaPowerOff onClick={onLogout}/>
              </LoginStatusBanner>
            </>
          ) : (

            <>
              <CiUser />
              <p><Link to="/login">Iniciar sesión</Link></p>
            </>
          )}
        </SignInContainer>


        <MenuMobile isOpen={isOpen} setIsOpen={setIsOpen} isLoggedIn={isLoggedIn} />
      </MenuContainer>
    </HeaderContainer>
  );
};

export default Header;
